import React from 'react';

const AdminSpinner = () => {
    return (
        <div className="main-spinner-container">
            <span className="loader"></span>
        </div>

    );
}

export default AdminSpinner;
